import { BrowserRouter, Switch } from 'react-router-dom';
import {
  AppAuthenticated,
  Authenticated,
  I18nContextProvider,
  user,
  SentryRoute as Route,
  I18nWrapper,
} from '@miotech/shared';
import 'normalize.css';
import Container from 'container';
import { ConfigProvider } from 'antd';
import { ThemeProvider } from '@miotech/prism';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import locale from 'antd/locale/zh_CN';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import PermissionsProvider from 'components/authority-session';
import AuthorityRw from 'components/authority-r-w';
import OutsideAuthenticated from 'components/outside-authenticated';
import OutsideContainer from 'outside-container';
import { isOutsideSystem } from 'utils/utils';
import { UserLanguage } from '@miotech/shared/lib/src/types';

const appPath = `/gvi`;
// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   'pdfjs-dist/build/pdf.worker.min.js',
//   import.meta.url,
// ).toString();
// cdn 地址
// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

function App() {
  const isOutside = isOutsideSystem();
  const language = user.preference?.language || ('zh-CN' as UserLanguage);
  return (
    <I18nWrapper staticResource={{}} language={language}>
      <I18nContextProvider language={language} resourcePath={`${appPath}/locales`}>
        <BrowserRouter basename={appPath}>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: '#06C27F',
                colorError: '#FF6336',
                borderRadius: 2,
                colorText: '#262a2f',
                fontFamily: 'Roboto',
              },
            }}
            locale={locale}
          >
            <ThemeProvider
              value={{
                system: 'light',
                branding: 'brandingEsghub',
              }}
            >
              <Switch>
                {/* GVI系统内页面 */}
                <>
                  {isOutside ? (
                    // 外部系统页面
                    <OutsideAuthenticated>
                      <Route path="/" component={() => <Route path="/" component={OutsideContainer} />} />
                    </OutsideAuthenticated>
                  ) : (
                    // 内部系统页面
                    <Authenticated>
                      {/* @ts-ignore */}
                      <AppAuthenticated permission="GVI">
                        <PermissionsProvider>
                          <AuthorityRw>
                            <Route path="/" component={() => <Route path="/" component={Container} />} />
                          </AuthorityRw>
                        </PermissionsProvider>
                      </AppAuthenticated>
                    </Authenticated>
                  )}
                </>
              </Switch>
            </ThemeProvider>
          </ConfigProvider>
        </BrowserRouter>
      </I18nContextProvider>
    </I18nWrapper>
  );
}

export default App;
